import { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { Alert } from "react-bootstrap";

interface Props {
  route: string;
  method: string;
}

interface CustomJwtPayload extends JwtPayload {
  user_id: string;
}

const Form: React.FC<Props> = ({ route, method }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const navigate = useNavigate();

  const name = method === "login" ? "Login" : "Register";
  const locale = navigator.language;

  const handleSubmit = async (e: any) => {
    setLoading(true);
    setSuccessMessage(null);
    setErrorMessage(null);
    e.preventDefault();

    try {
      const params =
        method === "login"
          ? { username, password, website }
          : { username, email, locale, password, website };

      const res = await api.post(route, params, {
        headers: {
          "Content-Type": "application/json", // ✅ Assure l'envoi en JSON
        },
      });
      if (method === "login") {
        localStorage.setItem(ACCESS_TOKEN, res.data.access);
        localStorage.setItem(REFRESH_TOKEN, res.data.refresh);

        const decoded = jwtDecode<CustomJwtPayload>(res.data.access);
        localStorage.setItem("user_id", decoded.user_id);
        setSuccessMessage("Connection successful ✅");
        navigate("/");
      } else {
        // navigate("/login");

        setSuccessMessage(
          "Your account has been successfully created ✅ >>> We will notify you when the Vivanoda Travel AI application is fully operational."
        );
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const firstError = Object.values(data)[0];
        if (Array.isArray(firstError)) {
          setErrorMessage(firstError[0]); // Affiche la 1re erreur reçue
        } else if (typeof firstError === 'string') {
          setErrorMessage(firstError);
        } else {
          setErrorMessage('An error has occurred !');
        }
        
      } else {
        setErrorMessage(`An error occurred during ${method}.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {errorMessage && (
        <Alert
          variant="danger"
          onClose={() => setErrorMessage(null)}
          dismissible
        >
          {errorMessage}
        </Alert>
      )}

      {successMessage && (
        <Alert
          variant="success"
          onClose={() => setSuccessMessage(null)}
          dismissible
        >
          <strong>{successMessage}</strong>
        </Alert>
      )}

      {!successMessage && (
<form onSubmit={handleSubmit} className="form-container">
        <h2 className="mb-3 text-center">{name}</h2>

        <div className="mb-3">
          <label className="form-label">Username</label>
          <input
            className="form-control"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
          />
        </div>

        {method === "register" && (

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                required
              />
            </div>

        )}

        <div className="mb-3 d-none">
          <label className="form-label">Website</label>
          <input
            className="form-control"
            type="text"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            placeholder="Website"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            className="form-control"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
        </div>

        <button
          className="btn btn-primary w-100"
          type="submit"
          disabled={loading}
        >
          {name}
        </button>
      </form>
      )}

      
    </>
  );
};

export default Form;
